class SectionBitmap implements ng.IComponentController {
    ltTitle: string;
    description: string;
}

angular.module('animatronApp.sectionBitmap', []).component('sectionBitmap', {
    bindings: {
        ltTitle: '<',
        description: '<'
    },
    controller: SectionBitmap,
    templateUrl: require('landing-template/components/sections/section-bitmap.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/landing-template/components/sections/SectionBitmap.ts